import React from 'react';

const SvgBeTheCustomer = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-CoreValues-BeTheCustomer__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "tourlane-CoreValues-BeTheCustomer__path-3",
  cx: 26.506,
  cy: 26.63,
  rx: 26.506,
  ry: 26.63
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-CoreValues-BeTheCustomer__path-1",
  d: "M18.278 0S10.764 1.902 5.02 11.26C-.726 20.616.033 27.326.033 27.326H0h64.337s.76-6.71-4.986-16.068C54.604 3.526 48.648.282 46.723.05H32.185L18.278 0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 62.553)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-CoreValues-BeTheCustomer__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-CoreValues-BeTheCustomer__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-CoreValues-BeTheCustomer__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M32.185 27.327H0V0h32.185z",
  mask: "url(#tourlane-CoreValues-BeTheCustomer__mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#BDBDBD",
  transform: "translate(44.96 75.43)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.314,
  cy: 1.314,
  r: 1.314
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.314,
  cy: 7.357,
  r: 1.314
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M68.523 74.116c.568 0 1.03.46 1.03 1.03v.517a1.03 1.03 0 01-1.03 1.03l-1.476-.001v5.411a1.03 1.03 0 01-1.03 1.03h-.445a1.03 1.03 0 01-1.03-1.03v-5.411h-1.475a1.03 1.03 0 01-1.03-1.03v-.517c0-.568.462-1.03 1.03-1.03h5.456z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M57.865 66.358l-5.68 13.202V66.357h5.68z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.68 15)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-CoreValues-BeTheCustomer__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-CoreValues-BeTheCustomer__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-CoreValues-BeTheCustomer__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M34.625-1.314c0 11.832-9.592 21.423-21.423 21.423H0V-1.314h34.625z",
  mask: "url(#tourlane-CoreValues-BeTheCustomer__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M31.528.53s2.736 17.57 20.74 19.58C49.08-1.315 31.528.53 31.528.53z",
  mask: "url(#tourlane-CoreValues-BeTheCustomer__mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#8D8D8D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.246 53.126a1.416 1.416 0 011.943.509 1.43 1.43 0 01-.506 1.952c-2.357 1.388-5.058 2.08-8.077 2.08-3.005 0-5.783-.686-8.311-2.055a1.43 1.43 0 01-.577-1.933 1.417 1.417 0 011.924-.579c2.109 1.142 4.423 1.713 6.964 1.713 2.529 0 4.733-.564 6.64-1.687zM45.108 43.776a1.132 1.132 0 001.606-.052 1.145 1.145 0 00-.052-1.613c-1.553-1.463-3.378-2.21-5.422-2.21-2.03 0-3.898.736-5.563 2.178a1.145 1.145 0 00-.118 1.61 1.132 1.132 0 001.602.119c1.262-1.094 2.609-1.625 4.08-1.625 1.457 0 2.729.52 3.867 1.593zM67.827 43.776a1.132 1.132 0 001.606-.051 1.145 1.145 0 00-.052-1.613c-1.553-1.463-3.378-2.21-5.421-2.21-2.031 0-3.9.736-5.564 2.178a1.145 1.145 0 00-.118 1.61 1.132 1.132 0 001.602.119c1.262-1.094 2.609-1.625 4.08-1.625 1.457 0 2.729.52 3.867 1.593z"
})))));

export default SvgBeTheCustomer;